// Single source of truth for the Campaigns table filter shape. Both the initial
// filter state and the "Reset Filters" action derive from this, so adding a new
// filter here keeps the two in sync.
export const EMPTY_CAMPAIGN_FILTERS = Object.freeze({
  name: '',
  campaignId: '',
  campaignDemandSource: '',
  detailedStatus: '',
  country: '',
  industry: '',
  startDate: '',
  endDate: '',
  brandMetricType: '',
});

export const CAMPAIGN_DETAILED_STATUSES = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  MANUAL: 'Manual',
  COMPLETE: 'Complete',
  UNKNOWN: 'Unknown',
};

export const CAMPAIGN_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const CAMPAIGN_STATUSES_LIST = [
  {
    value: CAMPAIGN_STATUSES.ACTIVE,
    label: 'Active',
  },
  {
    value: CAMPAIGN_STATUSES.INACTIVE,
    label: 'Inactive',
  },
];

export const CAMPAIGN_DEMAND_SOURCES = {
  PORTAL: 'PORTAL',
  DTADS: 'DTADS',
  PMP: 'PMP',
  DTBIDDER: 'DTBIDDER',
};

export const CAMPAIGN_DEMAND_SOURCES_LIST = [
  {
    value: CAMPAIGN_DEMAND_SOURCES.PORTAL,
    label: 'Portal (Campaign IDs)',
  },
  {
    value: CAMPAIGN_DEMAND_SOURCES.DTADS,
    label: 'DT Ads (Campaign IDs)',
  },
  {
    value: CAMPAIGN_DEMAND_SOURCES.PMP,
    label: 'PMP (Deal IDs)',
  },
  {
    value: CAMPAIGN_DEMAND_SOURCES.DTBIDDER,
    label: 'DT Bidder (Campaign UUIDs)',
  },
];
